module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-list"
  }, [_c('div', {
    staticClass: "category-list__title"
  }, [_vm._v("アイテムカテゴリ")]), _vm._v(" "), _c('table', [_c('thead', {
    staticClass: "category-list__header"
  }, [_c('tr', [_c('th', {
    staticClass: "category-list__header-name sort-label",
    class: _vm.cssCategoryHeaderSort('order'),
    on: {
      "click": function($event) {
        return _vm.changeCategorySortOption('order')
      }
    }
  }, [_vm._v("名称\n        "), _c('span', {
    staticClass: "sort-icon sort-icon__up"
  }, [_vm._v("▲")]), _vm._v(" "), _c('span', {
    staticClass: "sort-icon sort-icon__down"
  }, [_vm._v("▼")])])])]), _vm._v(" "), _c('tbody', {
    staticClass: "category-list__body"
  }, _vm._l((_vm.categorys), function(category, index) {
    return _c('tr', {
      staticClass: "category-list__row",
      class: _vm.selectRow(category.id),
      attrs: {
        "tabindex": "0",
        "id": ("category-" + index)
      },
      on: {
        "click": function($event) {
          return _vm.selectCategory(category.id)
        },
        "!keydown": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
        },
        "keydown": [function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.selectCategory(category.id)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
          return _vm.changeFocusByUpKey(_vm.categorys, index)
        }, function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
          return _vm.changeFocusByDownKey(_vm.categorys, index)
        }]
      }
    }, [_c('td', {
      staticClass: "category-list__item",
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(category.name))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42ee78c4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./src/components/aftersale/predict/categorylist/categorylist.html
// module id = 678
// module chunks = 0